import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import { EField } from "./schema.kycVerification.types";

export const submitActionCreator =
  (contactId: number, asBroker = false, bankAccountId?: number) =>
  (formData: any) =>
    contactActions.kycContact.actions.start({
      contactId,
      bankAccountId,
      contact: {
        dateOfBirth: formData[EField.DateOfBirth],
        nationality: formData[EField.Nationality],
        ...formData[EField.Address],
        countryId: formData[EField.Address].country,
      },
      idCardFront: formData[EField.IdCardFront][0],
      idCardBack: formData[EField.IdCardBack][0],
      asBroker,
    });
